import * as products from 'app/mocks/data/catalogue/products/list'
import * as terminals from 'app/mocks/data/machines/all/terminals'
import * as managers from 'app/mocks/data/park/managers/list'
import * as sites from 'app/mocks/data/park/sites/list'
import * as konvives from 'app/mocks/data/users/konvives/list'

import { newDateFormatted } from 'app/utils/date'

import {
    Order,
    ReasonCancelOrder,
    StatusOrder,
} from 'app/types/operations/order'

export const order501: Order = {
    id: 501,
    status: StatusOrder.enum.CANCELLED,
    phone_number: '0621443517',
    site: sites.site1,
    terminal: terminals.terminal1,
    reason: ReasonCancelOrder.enum.KONVIVE,
    price: 5,
    articles: [
        {
            product: products.product2,
            is_weight_quantity: true,
            quantity: 500,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-20)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0621443517',
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-20)}T09:30:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-20)}T10:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager1,
            changes: [],
        },
    ],
}

export const order502: Order = {
    id: 502,
    status: StatusOrder.enum.CANCELLED,
    konvive: konvives.konvive2,
    site: sites.site2,
    terminal: terminals.terminal2,
    reason: ReasonCancelOrder.enum.KONVIVE,
    price: 5,
    articles: [
        {
            product: products.product3,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product4,
            is_weight_quantity: true,
            quantity: 750,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-19)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive2,
            changes: [
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 4,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-19)}T10:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager1,
            changes: [],
        },
    ],
}

export const order503: Order = {
    id: 503,
    status: StatusOrder.enum.CANCELLED,
    phone_number: '0632554178',
    site: sites.site3,
    terminal: terminals.terminal3,
    price: 5,
    reason: ReasonCancelOrder.enum.STOCK,
    articles: [
        {
            product: products.product5,
            is_weight_quantity: true,
            quantity: 400,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-18)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0632554178',
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-18)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: '0632554178',
            changes: [],
        },
    ],
}

export const order504: Order = {
    id: 504,
    status: StatusOrder.enum.CANCELLED,
    konvive: konvives.konvive3,
    site: sites.site4,
    terminal: terminals.terminal4,
    reason: ReasonCancelOrder.enum.OTHER,
    price: 5,
    articles: [
        {
            product: products.product6,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product7,
            is_weight_quantity: true,
            quantity: 300,
        },
        {
            product: products.product8,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-17)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive3,
            changes: [
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 500,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-18)}T12:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager5,
            changes: [
                {
                    product: products.product6,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product7,
                    is_weight_quantity: true,
                    quantity: 300,
                },
                {
                    product: products.product8,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-18)}T12:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager5,
            changes: [],
        },
    ],
}

export const order505: Order = {
    id: 505,
    status: StatusOrder.enum.CANCELLED,
    phone_number: '0643665289',
    site: sites.site5,
    terminal: terminals.terminal1,
    reason: ReasonCancelOrder.enum.OTHER,
    price: 5,
    articles: [
        {
            product: products.product9,
            is_weight_quantity: true,
            quantity: 600,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-16)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0643665289',
            changes: [
                {
                    product: products.product9,
                    is_weight_quantity: true,
                    quantity: 600,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-16)}T09:30:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-16)}T10:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager1,
            changes: [],
        },
    ],
}

export const order506: Order = {
    id: 506,
    status: StatusOrder.enum.CANCELLED,
    konvive: konvives.konvive4,
    site: sites.site6,
    terminal: terminals.terminal2,
    reason: ReasonCancelOrder.enum.KONVIVE,
    price: 5,
    articles: [
        {
            product: products.product10,
            is_weight_quantity: false,
            quantity: 4,
        },
        {
            product: products.product11,
            is_weight_quantity: true,
            quantity: 250,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-15)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-15)}T10:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager2,
            changes: [],
        },
    ],
}

export const order507: Order = {
    id: 507,
    status: StatusOrder.enum.CANCELLED,
    phone_number: '0654776391',
    site: sites.site7,
    terminal: terminals.terminal3,
    reason: ReasonCancelOrder.enum.OTHER,
    price: 5,
    articles: [
        {
            product: products.product12,
            is_weight_quantity: true,
            quantity: 800,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-14)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: managers.manager2,
            changes: [
                {
                    product: products.product10,
                    is_weight_quantity: false,
                    quantity: 4,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-14)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-15)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager2,
            changes: [],
        },
    ],
}

export const order508: Order = {
    id: 508,
    status: StatusOrder.enum.CANCELLED,
    konvive: konvives.konvive5,
    site: sites.site8,
    terminal: terminals.terminal4,
    reason: ReasonCancelOrder.enum.KONVIVE,
    price: 5,
    articles: [
        {
            product: products.product13,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product14,
            is_weight_quantity: true,
            quantity: 350,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-13)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive5,
            changes: [
                {
                    product: products.product13,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product14,
                    is_weight_quantity: true,
                    quantity: 200,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-13)}T10:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager1,
            changes: [],
        },
    ],
}

export const order509: Order = {
    id: 509,
    status: StatusOrder.enum.CANCELLED,
    phone_number: '0665887432',
    site: sites.site9,
    terminal: terminals.terminal1,
    reason: ReasonCancelOrder.enum.STOCK,
    price: 5,
    articles: [
        {
            product: products.product15,
            is_weight_quantity: true,
            quantity: 450,
        },
        {
            product: products.product16,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-12)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0665887432',
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-12)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager3,
            changes: [],
        },
    ],
}

export const order510: Order = {
    id: 510,
    status: StatusOrder.enum.CANCELLED,
    konvive: konvives.konvive6,
    site: sites.site10,
    terminal: terminals.terminal2,
    reason: ReasonCancelOrder.enum.OTHER,
    price: 5,
    articles: [
        {
            product: products.product17,
            is_weight_quantity: true,
            quantity: 550,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-11)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive6,
            changes: [
                {
                    product: products.product17,
                    is_weight_quantity: true,
                    quantity: 300,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-11)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager7,
            changes: [],
        },
    ],
}

export const order511: Order = {
    id: 511,
    status: StatusOrder.enum.CANCELLED,
    phone_number: '0676998543',
    site: sites.site11,
    terminal: terminals.terminal3,
    reason: ReasonCancelOrder.enum.OTHER,
    price: 5,
    articles: [
        {
            product: products.product18,
            is_weight_quantity: true,
            quantity: 425,
        },
        {
            product: products.product19,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-10)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0676998543',
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-10)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager7,
            changes: [],
        },
    ],
}

export const order512: Order = {
    id: 512,
    status: StatusOrder.enum.CANCELLED,
    konvive: konvives.konvive7,
    site: sites.site12,
    terminal: terminals.terminal4,
    reason: ReasonCancelOrder.enum.OTHER,
    price: 5,
    articles: [
        {
            product: products.product20,
            is_weight_quantity: false,
            quantity: 5,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-11)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-11)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager6,
            changes: [],
        },
    ],
}

export const order513: Order = {
    id: 513,
    status: StatusOrder.enum.CANCELLED,
    phone_number: '0687109654',
    site: sites.site13,
    terminal: terminals.terminal1,
    reason: ReasonCancelOrder.enum.OTHER,
    price: 5,
    articles: [
        {
            product: products.product21,
            is_weight_quantity: true,
            quantity: 675,
        },
        {
            product: products.product22,
            is_weight_quantity: true,
            quantity: 325,
        },
        {
            product: products.product23,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-10)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-10)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager6,
            changes: [],
        },
    ],
}

export const order514: Order = {
    id: 514,
    status: StatusOrder.enum.CANCELLED,
    konvive: konvives.konvive8,
    site: sites.site14,
    terminal: terminals.terminal2,
    reason: ReasonCancelOrder.enum.OTHER,
    price: 5,
    articles: [
        {
            product: products.product24,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-9)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-9)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager4,
            changes: [],
        },
    ],
}

export const order515: Order = {
    id: 515,
    status: StatusOrder.enum.CANCELLED,
    phone_number: '0698220765',
    site: sites.site15,
    terminal: terminals.terminal3,
    reason: ReasonCancelOrder.enum.STOCK,
    price: 5,
    articles: [
        {
            product: products.product1,
            is_weight_quantity: true,
            quantity: 525,
        },
        {
            product: products.product2,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-8)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0698220765',
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-8)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager4,
            changes: [],
        },
    ],
}

export const order516: Order = {
    id: 516,
    status: StatusOrder.enum.CANCELLED,
    konvive: konvives.konvive9,
    site: sites.site16,
    terminal: terminals.terminal4,
    reason: ReasonCancelOrder.enum.OTHER,
    price: 5,
    articles: [
        {
            product: products.product3,
            is_weight_quantity: true,
            quantity: 275,
        },
        {
            product: products.product4,
            is_weight_quantity: true,
            quantity: 450,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-7)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-7)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager9,
            changes: [],
        },
    ],
}

export const order517: Order = {
    id: 517,
    status: StatusOrder.enum.CANCELLED,
    phone_number: '0609331876',
    site: sites.site17,
    terminal: terminals.terminal1,
    reason: ReasonCancelOrder.enum.STOCK,
    price: 5,
    articles: [
        {
            product: products.product5,
            is_weight_quantity: false,
            quantity: 4,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-6)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0609331876',
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-6)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager9,
            changes: [],
        },
    ],
}

export const order518: Order = {
    id: 518,
    status: StatusOrder.enum.CANCELLED,
    konvive: konvives.konvive10,
    site: sites.site18,
    terminal: terminals.terminal2,
    reason: ReasonCancelOrder.enum.OTHER,
    price: 5,
    articles: [
        {
            product: products.product6,
            is_weight_quantity: true,
            quantity: 625,
        },
        {
            product: products.product7,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product8,
            is_weight_quantity: true,
            quantity: 375,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-5)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-5)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager10,
            changes: [],
        },
    ],
}

export const order519: Order = {
    id: 519,
    status: StatusOrder.enum.CANCELLED,
    phone_number: '0620442987',
    site: sites.site19,
    terminal: terminals.terminal3,
    reason: ReasonCancelOrder.enum.OTHER,
    price: 5,
    articles: [
        {
            product: products.product9,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-4)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0620442987',
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-4)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager10,
            changes: [],
        },
    ],
}

export const order520: Order = {
    id: 520,
    status: StatusOrder.enum.CANCELLED,
    konvive: konvives.konvive1,
    site: sites.site20,
    terminal: terminals.terminal4,
    reason: ReasonCancelOrder.enum.OTHER,
    price: 5,
    articles: [
        {
            product: products.product10,
            is_weight_quantity: true,
            quantity: 550,
        },
        {
            product: products.product11,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-3)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-3)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager8,
            changes: [],
        },
    ],
}
